module.exports = __webpack_public_path__ + "static/2017-cabo-df3fd40f0a717e1e1ca4ba9ee3a0f101.pdf";